import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { AppTextField } from '@vyce/core/src/components/inputs';
import { ButtonTitleWithLoading } from '@vyce/core/src/components';

interface Props {
  open: boolean;
  initialName: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void | Promise<void>;
}

export const RenameFolderDialog: React.FC<Props> = ({
  open,
  initialName,
  loading = false,
  onClose,
  onConfirm,
}) => {
  const [name, setName] = useState<string>(initialName);

  useEffect(() => {
    if (open) setName(initialName);
  }, [open, initialName]);

  const trimmed = name.trim();
  const canSave = !!trimmed && trimmed !== initialName.trim();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Rename folder</DialogTitle>
      <DialogContent>
        <AppTextField
          value={name}
          onChange={e => setName(e.target.value)}
          label="Folder name"
          fullWidth
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button size="large" variant="outlined" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          size="large"
          style={{ minWidth: 115 }}
          color="primary"
          onClick={() => onConfirm(trimmed)}
          variant="contained"
          disabled={!canSave || loading}
        >
          <ButtonTitleWithLoading title="Save" loaderVariant="paper" loading={!!loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
